import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SideMenu } from '../models';

export interface Portal {
    grupo_usuario: string;
    link: string;
}

@Injectable({
    providedIn: 'root',
})
export class PortalService {
    private _portais = new BehaviorSubject<Array<Portal>>([]);
    get portais() {
        return this._portais.asObservable();
    }

    private _portalTitle = new BehaviorSubject<string>('');
    get portalTitle() {
        return this._portalTitle.asObservable();
    }

    private _links = new BehaviorSubject<Array<SideMenu>>([]);
    get links() {
        return this._links.asObservable();
    }

    setPortais(portais: string[]) {
        return this._portais.next(this.parsePortais(portais));
    }

    setPortalTitle(portalTitle: string) {
        return this._portalTitle.next(portalTitle);
    }

    setLinks(links: Array<SideMenu>) {
        return this._links.next(links);
    }

    getLinks() {
        return this._links.value;
    }

    private parsePortais(portais: string[]): Portal[] {
        return portais.map(portal => ({
            grupo_usuario: portal,
            link: this.getLinkFromPortalName(portal),
        }));
    }

    private getLinkFromPortalName(portalName: string): string {
        const linkMap = {
            Colaborador: '/',
            Administrador: '/administrador',
            Coordenador: '/coordenador',
            Gestor: '/gestor',
        };
        return linkMap[portalName] || '/';
    }
}
